import React from "react";

export const DoNotSell = () => {
  return (
    <h1 className="text-green m-t-100 p-t-100 p-b-100">Our Do Not Sell My Personal Information page will be coming soon!</h1>
  );
}

export default DoNotSell;